const BaseComponent = require('base/base-component');

class timeChain extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .tl-btn': 'handleClick'
      }
    });
  }
  init () {
    this.data = JSON.parse(this.$el.find('[name=relevant-articles]').val());
    this.renderTimeBase(this.data);
  }
  // 渲染时间轴
  renderTimeBase (datasource) {
    const data = datasource.filter(item => item.typeName !== '项目信息');
    let htmlStr = '';
    let len = data.length;
    let triggerTimes = 0;
    this.$chainBox = this.$el;
    this.$chainBtn = this.$chainBox.find('.tl-btn');
    this.$chainContainer = this.$chainBox.find('.tl-container');
    for (let i = 0; i < len; i++) {
      if (data[i].isExist == 1) {
        if (data[i].isCurrent == 1) {
          if (i > 9) {
            triggerTimes = Math.floor((i - 1) / 9);
          }
          htmlStr +=
            `<li class='tl-col' name='now' data-info='${JSON.stringify(data[i])}'>
                ${i == 0 ? '' : '<div class=\'tl-horizontal\'></div>'}
                <p class="tl-time">${data[i].pubDate ? data[i].pubDate.slice(0, 10) : ''}</p>
                <i class="icon iconfont icon-icon_circle1" data-type='${data[i].type}' data-id='${data[i].id}'></i>
                <a class="tl-info" href="${data[i].url}">
                    ${data[i].typeName}
                    <span class="triangle"></span>
                </a>
            </li>`;
        } else {
          htmlStr += `<li class='tl-col' data-info='${JSON.stringify(data[i])}'>
                ${i == 0 ? '' : '<div class=\'tl-horizontal\'></div>'}
                <p class="tl-time">${data[i].pubDate ? data[i].pubDate.slice(0, 10) : ''}</p>
                <i class="icon iconfont icon-notify-success" data-type='${data[i].type}'  data-id='${data[i].id}'></i>
                <a class="tl-info" href="${data[i].url}">${data[i].typeName}</a>
            </li>`;
        }
      } else {
        htmlStr += `<li class='tl-col' data-info='${JSON.stringify(data[i])}'>            
            ${i == 0 ? '' : '<div class="tl-horizontal" name="ntyt"></div>'}
            <i class="icon iconfont icon-quan" ></i>
            <a class="tl-info" name="ntyt" href="javascript:;">${data[i].typeName}</a>
        </li>`;
      }
    }
    this.$chainContainer.html(htmlStr);
    this.$chainBox.addClass('show');
    if (!this.countNum) {
      this.countNum = 0;
    }
    this.limit = Math.floor((len - 1) / 9);
    if (this.limit > 0) {
      if (this.countNum < this.limit) {
        this.$chainBtn.show().eq(1).addClass('canClick');
        // 时间轴移动到当前
        if (triggerTimes !== 0) {
          while (triggerTimes > 0) {
            this.$el.find('.tl-btn[data-type="right"]').trigger('click');
            triggerTimes--;
          }
        }
      }
    } else if (len !== 9) { // 少于九个居中显示
      const leftValue = (890 - len * 95) / 2 - 45;
      this.$chainContainer.css({
        left: leftValue
      });
    }
  }

  handleClick (e) {
    let $target = $(e.target || e.srcElement);
    if (!$target.hasClass('canClick')) {
      return;
    }
    let leftVal = null;
    if ($target.data('type') === 'left') {
      if (this.countNum <= 1) {
        $target.removeClass('canClick');
      }
      if (this.countNum == this.limit) {
        this.$chainBtn.eq(1).addClass('canClick');
      }
      this.countNum--;
      console.log(this.countNum);
      leftVal = -890 * this.countNum + 'px';
    } else {
      if (this.countNum >= (this.limit - 1)) {
        $target.removeClass('canClick');
      }
      if (this.countNum == 0) {
        this.$chainBtn.eq(0).addClass('canClick');
      }
      this.countNum++;
      leftVal = -890 * this.countNum + 'px';
    }
    $('.tl-container').animate({
      left: leftVal
    }, 'slow');
  }
}
module.exports = timeChain;
